<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 查询管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>消费者查询</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="码" prop="qrcode">
                <el-input v-model="searchform.qrcode" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品编码" prop="product_code">
                <el-select
                  v-model="searchform.product_code"
                  placeholder="请输入产品名称模糊匹配或者下拉选择"
                  style="width:100%"
                  :remote-method="getproductlist"
                  filterable
                  remote
                  :loading="productloading"
                  :disabled="show"
                >
                  <el-option
                    v-for="item in productlist"
                    :key="item.product_code"
                    :label="item.product"
                    :value="item.product_code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
           <el-col :span="6">
              <el-form-item label="品牌" prop="brandId">
                <el-select type="text" v-model="searchform.brandId" style="width:100%">
                  <el-option
                    v-for="item in brandlist"
                    :key="item.brand_id"
                    :label="item.brand_name"
                    :value="item.brand_id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="扫码时间" prop="datelist" >
                   <el-date-picker
                           style="width:100%"
                           v-model="searchform.datelist"
                           type="daterange"
                           value-format="timestamp"
                           range-separator="-"
                           start-placeholder="开始日期"
                           end-placeholder="结束日期">
                   </el-date-picker>
              </el-form-item>
            </el-col>     
          </el-row>
                      <el-row>
            <el-col :span="16" :offset="1"> 
               <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search" v-permission="['customerquery_select']">搜索</el-button>
              <el-button
              v-permission="['customerquery_export']"
                :loading="downloadLoading"
                type="primary"
                icon="document"
                @click="handleDownload"
              >导出Excel</el-button>
              <!-- <FilenameOption v-model="filename"   v-permission="['customerquery_export']"/> -->
            </el-col>
            </el-row> 
        </el-form>
      </div>
<br>
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>消费者扫码查询</h4>
          <el-divider></el-divider>
          <el-table
            border
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            id="parent"
          >
            <el-table-column prop="product" label="产品编码" width="260" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qrcode" label="码" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="brandId" label="品牌ID" width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="brandName" label="品牌名称" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="provinceCodeScan" label="省份" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="cityCodeScan" label="城市" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="scanTime" label="扫码时间" min-width="120" show-overflow-tooltip fixed="right"></el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import {
  productTree,
} from "@/api/base";
import { queryconsumer } from "@/api/physical";
import FilenameOption from "@/views/excel/components/FilenameOption";
import { productlist } from "@/api/base";
export default {
  
    components: { FilenameOption },
  mounted() {
    //请求部门列表数据并且便利到表格
    this.Tabledata();
    this.getproductlist();
  },
  data() {
    return {
      //基础数据
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      brandlist:[],     
      //产品列表下拉
      productloading: false,
      show: false,
      productlist: [], 
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
       //导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //搜索表单数据
      searchform: {
        brandId:null,
        product_code:null,
        freight_bill_code: null,
        datelist:[],
        sout_bill_date: null,
        eout_bill_date:null,
        from_warehouse_code: null,
        dealer_code:null,
        product_code:null,
        currPage:1,
        pageSize:10
      }
    };
  },
  methods: {
     // 获取产品下拉
    getproductlist(value) {
      this.productlist = [];
      if (value !== "") {
        this.productloading = true;
        setTimeout(() => {
          this.productloading = false;
          productlist({ productName: value }).then(response => {
            this.productlist = response.data.data;
            for (var i = 0; i < this.productlist.length; i++) {
              this.productlist[i].product =
                this.productlist[i].product_code +
                "   " +
                this.productlist[i].product_name;
            }
          });
        }, 200);
      } else {
        this.productlist = [];
      }
    },
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      queryconsumer(obj).then(response => {
        this.tableData = response.data.list;
        this.packdate(this.tableData)
        this.total_count = response.data.totalCount;
        this.currentPage = response.data.currPage;
        this.listLoading = false;
        console.log(this.tableData)
      });
      productTree().then(response => {
        this.brandlist=response.data
        console.log(this.brandlist)
         });
    },
    packdate(obj){
      for (let i = 0; i < obj.length; i++) {
         obj[i].scanTime =  this.$parseTime(obj[i].scanTime);
         obj[i].product = (obj[i].productCode || ' ' ) + (obj[i].productName || ' ' );
        }
    },
    //搜索事件
    search() {
        this.Tabledata({
          brandId:this.searchform.brandId,
        product_code:this.searchform.product_code,
        qrcode: this.searchform.qrcode,
        sscan_time: this.searchform.datelist==null ? null:this.searchform.datelist[0],
        escan_time: this.searchform.datelist==null ? null:this.searchform.datelist[1],
        pageSize:this.searchform.pageSize
        });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.currPage = currPage
       this.Tabledata({
         brandId:this.searchform.brandId,
          product_code:this.searchform.product_code,
        qrcode: this.searchform.qrcode,
        sscan_time: this.searchform.datelist==null ? null:this.searchform.datelist[0],
        escan_time: this.searchform.datelist==null ? null:this.searchform.datelist[1],
        currPage:this.searchform.currPage,
        pageSize:this.searchform.pageSize
        });
      console.log(currPage)
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize
      this.search()
    },
    //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        page_index: 1,
        pageSize: this.total_count,
        brandId:this.searchform.brandId,
         product_code:this.searchform.product_code,
         qrcode: this.searchform.qrcode,
        sscan_time: this.searchform.datelist==null ? null:this.searchform.datelist[0],
        escan_time: this.searchform.datelist==null ? null:this.searchform.datelist[1],
      };
      queryconsumer(obj).then(response => {
        this.packdate(response.data.list)
        this.tableDataDownload = response.data.list;

        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = [
            "产品编码",
            "码",
            "品牌ID",
            "品牌名称",
            "省份",
            "城市",
            "扫码时间",
          ];
          const filterVal = [
            "product",
            "qrcode",
            "brandId",
            "brandName",
            "provinceCodeScan",
            "cityCodeScan",
            "scanTime",

          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}
.border {
  padding: 10px 10px;
  border-radius: 3px;
  border: 1px solid #e6ebf5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.handle-box {
  margin-bottom: 0px;
}
.handle-input {
  width: 160px;
  display: inline-block;
}
.del-dialog-cnt {
  font-size: 16px;
  text-align: center;
}
.mr10 {
  margin-right: 10px;
}
#parent {
  text-align: center;
}
</style>